import '../modals/CreateClientTeamConnectionModal/store/init';

import { fetchTeamConnections } from './effects';
import { $teamConnections } from './states';

// Fetch team connections
$teamConnections.on(fetchTeamConnections.doneData, (_, data) => data);
